import React from 'react';
import Badge from '../components/Badge';
import SVGIcon from '../components/SVGIcon';
import Tooltip from '../components/Tooltip';
import boltIcon from '../icons/bolt.svg';
import { openPricingModal } from '../utils/url/pricingPath';
import type { PlanFeatureKey } from './PricingConfig';
import styles from './UpgradeBadge.module.scss';
import { useAppDispatch } from '../app/redux/useAppSelector';

interface UpgradeBadgeProps {
  tooltip?: string;
  feature?: PlanFeatureKey;
}

const UpgradeBadge = ({ tooltip, feature }: UpgradeBadgeProps) => {
  const dispatch = useAppDispatch();

  const upgradeClick = () => {
    openPricingModal(dispatch, feature);
  };

  return (
    <Tooltip placement="top" tooltip={tooltip} trigger="hover">
      <Badge onClick={upgradeClick}>
        <div className={styles.wrapper}>
          <SVGIcon size="small" className={styles.boltIcon}>
            {boltIcon}
          </SVGIcon>
          UPGRADE
        </div>
      </Badge>
    </Tooltip>
  );
};

export default UpgradeBadge;
